import React from 'react';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import { AirbnbSlider, ValueLabelComponent } from './ProductsTable';

export function PriceSegmentInput(quiz, togglePriceQuestion, priceHeaderInput, marks, sliderValues, handleChange, highestPrice, segmentButtons, changeCurrentSegment, segmentItemCounters, currentSegment, showTextError, buttonTextInputs, updateButtonSegmentTexts) {
    return <div>
        <h4 className="font-weight-bolder">Select price segments (optional)</h4>
        <FormGroup>
            <FormControlLabel control={<Switch defaultChecked={quiz.showPriceQuestion} onChange={togglePriceQuestion} />} label="Enable price segment" />
        </FormGroup>
        <input onChange={priceHeaderInput} defaultValue={quiz.priceHeaderInput} className="form-control form-control-solid mb-15" placeholder="Type title..." />
        <AirbnbSlider
            ValueLabelComponent={ValueLabelComponent}
            marks={marks}
            value={sliderValues}
            onChange={handleChange}
            max={highestPrice}
            valueLabelDisplay="on"
            track={false}
            step={5} />
        <div style={{ textAlign: 'center' }}>
            {segmentButtons.map((button) => <button
                value={button.key}
                onClick={changeCurrentSegment}
                key={button.key}
                className={`btn ${segmentItemCounters[button.key] ? 'btn-light-danger btn-hover-danger' : 'btn-text-dark btn-hover-light-dark'} font-weight-bold mx-2 ${currentSegment === button.key ? 'active' : ''}`}
            >{button.text}
            </button>
            )}
            {showTextError &&
                <div>
                    Each cell in each segmant needs at least 1 product
                </div>}
        </div>
        <div style={{ textAlign: 'center' }}>
            {buttonTextInputs.map((input, index) => [
                <input
                    type="text"
                    style={{
                        margin: '14px 10px',
                        width: '137px',
                        display: 'inline',
                    }}
                    key={input.key}
                    name={index}
                    data-default={input.defaultPriceText}
                    onInput={updateButtonSegmentTexts}
                    className="form-control form-control-solid"
                    value={input.text} />
            ])}
        </div>
    </div>;
}
